<template>
  <section id="trackingRequestList" class="page-content">
      <header id="section-header">
          <p class="title has-text-grey">Tracking requests</p>
          <p class="subtitle has-text-grey">Search tracking requests.</p>
      </header>
      <main id="section-body">
        <div class="filters">
          <div class="filter">
            <label>Search</label>
            <div class="control">
              <input class="input" type="text" placeholder="Search for tracking requests..."
              v-model="filters.search" @keyup="debouncedGetAnswer" name="search" id="search">
            </div>
          </div>
          <div class="filter">
            <label>Tracking Status</label>
            <div class="control">
              <button-group-filter @change="debouncedGetAnswer" :collection="STATUS_FILTER" :target="filters.status" />
            </div>
          </div>
        </div>
        <div class="filters">
          <div class="filter">
            <label>Carrier</label>
            <div class="control">
              <div class="select">
                <select @change="debouncedGetAnswer" placeholder="Choose Carrier" name="carrier" id="carrier" v-model="filters.carrier">
                  <option value="">-----------</option>
                  <option v-for="carrier in carriers" :key="carrier.id" :value="carrier.id">{{ carrier.official_name }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="filter">
            <label>Last update</label>
            <date-range-filter @change="debouncedGetAnswer" ref="last_update" :dateMin.sync="filters.last_update_after" :dateMax.sync="filters.last_update_before"/>
          </div>
          <div class="filter">
            <label>Created</label>
            <date-range-filter @change="debouncedGetAnswer" ref="created_at" :dateMin.sync="filters.created_at_after" :dateMax.sync="filters.created_at_before"/>
          </div>
          <button class="filter-reset button is-small is-black" style="padding: 7px" @click="resetFilters" >
            <span>Reset Filters</span>&nbsp;&nbsp;<i class="fa fa-lg fa-eraser"/>
          </button>
          <button class="filter-reset button is-primary is-small" style="padding: 7px" @click="showCustomColumns=true" >
            <span>Configure Columns</span>&nbsp;&nbsp;<i class="fa fa-lg fa-columns"/>
          </button>
          <button class="filter-reset button is-small" style="padding: 7px" @click="exportList" >
            <span>Export List</span>&nbsp;&nbsp;<i class="fa fa-lg fa-file-excel-o"/>
          </button>
        </div>
        <spinner v-show="loadingList"></spinner>
        <div v-show="!loadingList">
            <data-table
            url="tracking-request"
            :editables="hasPermission('canWrite') ? {'client_code': {type: 'input'}, 'project': {type: 'combo', list: projects}} : ''"
            :expand="['shipments_count']"
            editUrl="tracking-requests"
            :titleStyle="'text-transform:uppercase;font-family: MuseoSans-700; color: #138366'"
            :objects="objects"
            :schema="schema"
            :ordering="selectedHeaders"
            @order="filters.ordering=$event;debouncedGetAnswer()"
            :totalItems="count"
            :title="'Tracking Requests'"
            :fields="columns"
            :alias="{'status': 'Tracking Status', 'created_at': 'created', 'client_code': 'Client Code', 'contractual_eta_pod': 'Contractual ETA POD' , 'contractual_eta_dlv': 'Contractual ETA DLV'}"
            :mappers="{'code_type': codeTypes, 'status': STATUS, 'shipments_health': SHIPMENTS_HEALTH}"
            @expand="loadTrackingRequest($event)"
            >
              <div slot-scope="actions" v-if="hasPermission('canWrite')">
                <modal-confirm
                :disabled="!actions.object.archivable"
                @confirm="retryTracking(actions.object)">
                  <div slot="title">Confirm Retry</div>
                  <span slot="body">Are you sure you want to <strong>retry</strong> this tracking?</span>
                  <div slot="footer">
                    <button class="button" @click="showModal = false; $emit('close')">
                      No, I'm not
                    </button>
                    <button class="button is-primary" @click="showModal = false; $emit('confirm')">
                      Yes, I'm sure
                    </button>
                  </div>
                  <div slot="trigger" class="button is-success is-small" v-if="['invalid'].indexOf(actions.object.status) >= 0">Retry</div>
                </modal-confirm>

                <modal-confirm
                :disabled="!actions.object.archivable"
                @confirm="changeStatus(actions.object, 'pending_archiving')">
                  <div slot="title">Confirm archive</div>
                  <span slot="body">Are you sure you want to <strong>archive</strong> this tracking?</span>
                  <div slot="footer">
                    <button class="button" @click="showModal = false; $emit('close')">
                      No, I'm not
                    </button>
                    <button class="button is-primary" @click="showModal = false; $emit('confirm')">
                      Yes, I'm sure
                    </button>
                  </div>
                  <div slot="trigger" class="button is-success is-small" v-if="['invalid', 'cancelled', 'archived', 'pending_archiving', 'pending_cancelling'].indexOf(actions.object.status) < 0">Archive</div>
                </modal-confirm>
                <modal-confirm
                :disabled="!actions.object.cancellable"
                @confirm="changeStatus(actions.object, 'pending_cancelling')">
                  <div slot="title">Confirm cancel</div>
                  <span slot="body">Are you sure you want to <strong>cancel</strong> this tracking?</span>
                  <div slot="footer">
                    <button class="button" @click="showModal = false; $emit('close')">
                      No, I'm not
                    </button>
                    <button class="button is-primary" @click="showModal = false; $emit('confirm')">
                      Yes, I'm sure
                    </button>
                  </div>
                  <div slot="trigger" class="button is-success is-small" v-if="['invalid', 'cancelled', 'archived', 'pending_archiving', 'pending_cancelling'].indexOf(actions.object.status) < 0">Cancel</div>
                </modal-confirm>
              </div>
              <template slot="status" slot-scope="scope">
                <span class="status-tag" :class="scope.obj.value">{{scope.obj.formated}}</span>
              </template>
            </data-table>
          <pagination
            :currentPage.sync="page"
            :totalItems="count"
            :itemsPerPage="pageSize"
            />
          <modal width="950px" v-if="showRequestModal && trackingRequest" @close="showRequestModal=false; trackingRequest={}">
            <div slot="header" style="font-family: MuseoSans-700; color: #138366;font-size:1.4em">
              {{trackingRequest.id}} TRACKING REQUEST SHIPMENTS
            </div>
            <div slot="body">
              <data-table
                url="shipment"
                :objects="trackingRequest.shipments"
                :schema="schema"
                :totalItems="count"
                :fields="detailTableheaders"
                :alias="{'status_verbose': 'status', 'container_type_str': 'Container Type', 'pol_loc': 'POL', 'pod_loc': 'POD', 'eta': 'ETA'}"
                >
              </data-table>
            </div>
          </modal>
          <modal v-if="showCustomColumns" :columns="tableHeaders" @close="showCustomColumns=false" width="90%">
            <div slot="header" style="font-weight: 400; margin-bottom:-15px;" class="title">Pick the columns you want to show</div>
            <custom-columns slot="body" :columns="tableHeaders" :previousSelected="selectedHeaders" @close="showCustomColumns=false; updateHeaders($event)"/>
          </modal>
        </div>
      </main>
  </section>
</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex'

import PaginatedFilteredListMixin from '@/pages/mixins/PaginatedFilteredListMixin'
import HealthFilter from '@/components/HealthFilter'
import ButtonGroupFilter from '@/components/ButtonGroupFilter'
import DateRangeFilter from '@/components/DateRangeFilter'
import DataTable from '@/components/DataTable'
import ModalConfirm from '@/components/ModalConfirm'
import Modal from '@/components/Modal'
import Pagination from '@/components/Pagination'
import Spinner from '@/components/Spinner'
import CustomColumns from '@/components/CustomColumns'
import _ from 'lodash'

import TrackingRequest from '@/models/trackingRequest'

export default {
  name: 'trackingRequestList',
  props: ['userInfo'],
  components: {ButtonGroupFilter, DateRangeFilter, DataTable, ModalConfirm, Pagination, Spinner, HealthFilter, Modal, CustomColumns},
  mixins: [PaginatedFilteredListMixin],
  created () {
    this.debouncedGetAnswer = _.debounce(this.applyFilters, 500)
  },
  mounted () {
    this.$emit('loading')
    this.loadHeaders()
    const promises = [
      this.getCarriers().then(response => { this.carriers = response }),
      this.getCodeTypes().then(response => { this.codeTypes = response }),
      this.getProjects().then(response => {
        this.projects = response
        this.projects.unshift({id: null, name: ''})
      }),
      this.getPage(this.page)
    ]
    Promise.all(promises).then(data => { this.$emit('loaded') })
  },
  data () {
    return {
      selectedHeaders: [],
      showCustomColumns: false,
      fixedHeaders: ['id'],
      tableHeaders: ['status', 'code_type', 'code_value', 'client_code', 'project', 'carrier', 'shipments_count', 'contractual_eta_pod', 'contractual_eta_dlv', 'created_at'],
      detailTableheaders: ['id', 'status_verbose', 'container_number', 'container_type_str', 'eta', 'pol_loc', 'pod_loc'],
      schema: TrackingRequest.schema(),
      STATUS: TrackingRequest.STATUS,
      STATUS_FILTER: TrackingRequest.STATUS_FILTER,
      SHIPMENTS_HEALTH: TrackingRequest.SHIPMENTS_HEALTH,
      projects: [],
      objects: [],
      codeTypes: [],
      carriers: [],
      filters: {
        search: '',
        status: [],
        shipments_health: '',
        carrier_id: null,
        last_update_after: null,
        last_update_before: null,
        created_at_after: null,
        created_at_before: null
      },
      trackingRequest: {},
      showRequestModal: false
    }
  },
  methods: {
    ...mapActions({
      getCarriers: 'carrier/list',
      getCodeTypes: 'codeType/list',
      getObjects: 'trackingRequest/list',
      transition: 'trackingRequest/transition',
      getTrackingRequest: 'trackingRequest/retrieve',
      getProjects: 'project/list',
      postTrackingRetry: 'trackingRequest/retry',
      exportTrackingRequest: 'trackingRequest/export',
      saveUserInfo: 'user/saveUserConfig'
    }),
    exportList () {
      document.body.style.cursor = 'wait'
      var params = Object.assign({},
        this.filters
      )
      params.page = undefined
      this.generating = true
      this.exportTrackingRequest(params).then(response => {
        document.body.style.cursor = 'default'
      }).catch(error => {
        document.body.style.cursor = 'default'
        throw error
      })
    },
    retryTracking (object) {
      this.postTrackingRetry(object.id).then(response => {
        this.$notify({
          group: 'global',
          title: 'Success',
          text: 'The Tracking status has been successfully changed',
          duration: 4000,
          type: 'success'
        })
        this.getPage(this.page)
      })
    },
    changeStatus (object, status) {
      var data = { id: object.id, newStatus: status }
      this.transition(data).then(response => { object.status = response.status })
    },
    loadTrackingRequest (object) {
      this.getTrackingRequest(object.id).then((response) => {
        this.trackingRequest = response
        this.showRequestModal = true
      })
    },
    updateHeaders (headers) {
      this.selectedHeaders = headers
      var user = this.userInfo.userprofile
      user.trackings_fields = this.selectedHeaders
      this.saveUserInfo({id: this.userInfo.id, userprofile: user})
    },
    loadHeaders () {
      this.selectedHeaders = this.tableHeaders.slice()
      if (this.userInfo && this.userInfo.userprofile && this.userInfo.userprofile.trackings_fields) {
        this.selectedHeaders = this.userInfo.userprofile.trackings_fields
      }
    }
  },
  computed: {
    ...mapState({
      count: state => state.trackingRequest.count,
      pageSize: state => state.pageSize
    }),
    ...mapGetters({hasPermission: 'hasPermission'}),
    columns () {
      var selectedHeaders = this.selectedHeaders.filter((x) => this.tableHeaders.indexOf(x) >= 0)
      let columns = this.fixedHeaders.concat(selectedHeaders)
      if (selectedHeaders.length === 0) {
        columns = columns.concat(this.tableHeaders)
      }
      return [...new Set(columns)]
    }
  },
  watch: {
    'page' () { this.getPage(this.page) },
    userInfo () {
      this.loadHeaders()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/PageTrackingRequestList.vue